import config from "@/config/config";

import Index from "@/pages/payment/index.vue";
import List from "@/pages/payment/list/list.vue";
import View from "@/pages/payment/view/view.vue";

const modulePermission = config.modules.productCategory;

export default {
  path: "/payment",
  name: "payment",
  component: Index,
  meta: {
    requiresAuth: true,
    modulePermission: modulePermission,
    requiresPermission: "enabled_read",
  },
  children: [
    {
      path: "list",
      name: "payment-list",
      component: List,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_read",
      },
    },
    {
      path: ":id",
      name: "payment-view",
      component: View,
      meta: {
        modulePermission: modulePermission,
        requiresPermission: "enabled_read",
      },
      props: true,
    },
  ],
};
